<script setup lang="ts">
import LeBookOpen from "@dsk/icons/LeBookOpen.vue";

import type { Dictionary } from "@/types";

import LeDictionaryCover from "./LeDictionaryCover.vue";

const props = defineProps<{
  dictionary: Dictionary;
  showIcon?: boolean;
  showDescription?: boolean;
}>();
</script>

<template>
  <div class="le-dictionary" :class="{ 'le-dictionary--with-description': props.showDescription }">
    <div
      class="le-dictionary__header le-dictionary__section"
      :class="{ 'le-dictionary__header--with-icon': props.showIcon }"
    >
      <LeDictionaryCover class="le-dictionary__dictionary-cover" :dictionary="props.dictionary" size="large" />
      <span class="le-dictionary__dictionary-title">{{ props.dictionary.title }}</span>
      <span class="le-dictionary__dictionary-publisher">{{ props.dictionary.publisher }}</span>
      <LeBookOpen v-if="props.showIcon" class="le-dictionary__dictionary-icon" role="presentation" />
    </div>

    <div v-if="props.showDescription" class="le-dictionary__description le-dictionary__section">
      {{ props.dictionary.intro }}
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-dictionary {
  width: 100%;
  background: @colors[@neutrals][100];
  box-shadow: @shadows[dropdown];
  color: @colors[@neutrals][300];

  &--with-description {
    background: @colors[@secondary][100];
  }

  &__section {
    padding: 12px;
  }

  &__header {
    display: grid;
    grid-template-areas:
      "cover title"
      "cover publisher";
    grid-template-columns: 30px auto;
    gap: 4px 12px;
    align-items: center;
    justify-content: start;
    background: @colors[@neutrals][100];

    &--with-icon {
      grid-template-areas:
        "cover title     icon"
        "cover publisher icon";
      grid-template-columns: 30px auto 24px;
      justify-content: stretch;
    }
  }

  &__description {
    background: @colors[@secondary][100];
    .body-text("s");
  }

  &__dictionary-cover {
    grid-area: cover;
  }

  &__dictionary-title {
    grid-area: title;
    height: 20px;
    overflow: hidden;
    color: @colors[@neutrals][400];
    text-overflow: ellipsis;
    white-space: nowrap;
    .body-text("s", "semi-bold");
  }

  &__dictionary-publisher {
    grid-area: publisher;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .body-text("s");
  }

  &__dictionary-icon {
    grid-area: icon;
    color: @colors[@neutrals][300];
  }
}
</style>
